import React, { useState } from "react"
import PropTypes from "prop-types"
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap"

import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { withRouter, Link, useHistory } from "react-router-dom"

import { logoutUser } from "store/actions"

import avatar from "../../../assets/images/dev/avatar-placeholder.png"

const ProfileMenu = props => {
  const history = useHistory()

  const [menu, setMenu] = useState(false)

  const logOut = e => {
    e.preventDefault()

    props.logoutUser({})
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user img-cover"
            src={props.user?.avatar ? props.user.avatar : avatar}
            alt="avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">
            {props.user?.name}
          </span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <Link
            to="/profile"
            className="dropdown-item"
            onClick={() => setMenu(false)}
          >
            <i className="bx bx-user font-size-16 align-middle me-1" />
            <span>{props.t("profile")}</span>
          </Link>

          <div className="dropdown-divider" />

          <Link to="#" onClick={logOut} className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  t: PropTypes.any,

  user: PropTypes.object,

  logoutUser: PropTypes.func,
}

const mapStateToProps = state => {
  const { data } = state.user.profile
  return {
    user: data,
  }
}

const mapDispatchToProps = {
  logoutUser,
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ProfileMenu))
)
